import { render } from "./proposalListByReserveComponent.vue?vue&type=template&id=5c2212af"
import script from "./proposalListByReserveComponent.vue?vue&type=script&lang=js"
export * from "./proposalListByReserveComponent.vue?vue&type=script&lang=js"

import "./proposalListByReserveComponent.vue?vue&type=style&index=0&id=5c2212af&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__